const CustomButton = ({
  text,
  boostrapIconClassName,
  onClick,
  className,
  pathfromImages,
}: {
  text: string
  boostrapIconClassName?: string
  className: string
  pathfromImages?: string
  onClick: () => void
}) => (
  <button className={`btn ${className}`} type='button' onClick={() => onClick()}>
    {Boolean(boostrapIconClassName) && (
      <span>
        <i className={`${boostrapIconClassName} fs-6`}></i>
      </span>
    )}
    {Boolean(pathfromImages) && (
      <img
        src={require(`../../_metronic/images/${pathfromImages}`)}
        alt=''
        className='svg-icon svg-icon-1 me-0'
      />
    )}

    <span className='ms-2'>{text}</span>
  </button>
)
export default CustomButton
